module.exports = __webpack_public_path__ + "img/successPay.9062851b.png";